"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const withFlags_1 = __importStar(require("../../withFlags"));
const LaunchDarklyDebug = ({ hasFlag }) => {
    (0, react_1.useEffect)(() => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'debugLaunchDarkly' does not exist on typ... Remove this comment to see the full error message
        if (window.debugLaunchDarkly) {
            // eslint-disable-next-line no-console
            console.log('testFlag: ', hasFlag(withFlags_1.Flags.testFlag));
        }
    }, []);
    return null;
};
exports.default = (0, withFlags_1.default)(LaunchDarklyDebug);
